module.exports = __webpack_public_path__ + "src/class3/img/gamehost-text.9d8d5b55.png";